import React, { Component } from 'react';

import { Button } from 'react-bootstrap';

class AuthModalNavButton extends Component {
  changeModalForm = () => {
    const { updateModal, formToDisplay } = this.props;
    updateModal({ formToDisplay });
  };

  render() {
    return (
      <Button bsStyle="link" onClick={this.changeModalForm}>
        {this.props.text}
      </Button>
    );
  }
}

export default AuthModalNavButton;



// WEBPACK FOOTER //
// ./src/Components/Auth/AuthModal/AuthModalNavButton.js